export default __webpack_public_path__ + "static/media/icon_100.fbf93339.png";